import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { Select } from '@ngxs/store';
import AOS from 'aos';

import { SystemStatistics } from '../../core/models';

@Component({
    selector: 'gs-how-it-works',
    templateUrl: './how-it-works.component.html',
    standalone: false
})
export class HowItWorksComponent implements OnInit, OnDestroy {
  @Select(state => state.staticData.systemStatistics) systemStatistics$: Observable<SystemStatistics>;

  private subscriptions: Subscription[] = [];

  constructor(
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      //Fix AOS not triggering when route animations are enabled
      AOS.refresh();
    }, 500);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
